module.exports = __webpack_public_path__ + "static/media/lumppu.ce99671b.png";